module.exports = __webpack_public_path__ + "img/bg-middle.6c3e3837.png";